<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <McButtonBack />
      </div>
      <div class="mc-company-tickets">
        <McGrapqlTable
          :apiClient="query"
          :fields="fields"
          :hasCheckbox="false"
          :searchable="false"
          :isSelectableField="false"
          :withCard="true"
          :stickyHeader="true"
          trackBy=""
        >
          <template #cell(activityOn)="data">
            {{ data.item ? momentDateShortMonth(data.item.activityOn) : '-' }}<br />
            <span class="text-muted">{{
              data.item ? momentTimeSeconds(data.item.activityOn) : '-'
            }}</span>
          </template>
        </McGrapqlTable>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import McGrapqlTable from '@/components/McGrapqlTable'
import McButtonBack from '@/components/McButtonBack'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import { GET_USER_LOGS } from '@/services/api/userlog'

export default {
  page: {
    title: 'Log Page',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McGrapqlTable,
    McButtonBack,
  },
  mixins: [Helper, MixPanel],
  computed: {
    title() {
      return 'User Logs'
    },
    fields() {
      return [
        { label: 'Email', key: 'email', isSortable: false },
        { label: 'Role', key: 'userRole', isSortable: false },
        { label: 'Date', key: 'activityOn', isSortable: false },
        { label: 'Activity', key: 'activity', isSortable: false },
        { label: 'Path', key: 'path', isSortable: false },
        { label: 'Detail', key: 'tabName', isSortable: false },
        { label: 'Component', key: 'component', isSortable: false },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          const res = await this.$apollo.query({
            query: GET_USER_LOGS,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                ...filter,
              },
            },
          })
          return res.data.userActionsLogs.userActionsLogs
        },
      }
    },
  },
  mounted() {
    this.track('Click User Logs')
  },
}
</script>
